module.exports = __webpack_public_path__ + "static/media/bg11.9d3777ab.jpg";